import * as THREE from 'three';
// import * as dat from 'dat.gui';
import { GUI } from 'three/examples/jsm/libs/lil-gui.module.min.js';
import {
  Develop, defines, MessageType, SkyParam, WalkThroughCameraControl, OrbitCameraControl
} from '../../base';
import { ThreeView, webcadDefines } from '..';
import * as marietta3d from '../../../../marietta3d';
import { TransformControls } from 'three/examples/jsm/controls/TransformControls';
import { VertexNormalsHelper } from 'three/examples/jsm/helpers/VertexNormalsHelper';
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer';
import { TexturePass } from 'three/examples/jsm/postprocessing/TexturePass';
import { HDREnvironment } from '../View3dWebCadEnviron';
import { Sky } from '../../base/View3dSky';
import { ZipCompression } from '../../../graphicLibs/compress/zipCompression';
import * as pixelstreamingCommand from '../../../pixelstreaming/commands'
import { RoomEnvironment } from 'three/examples/jsm/environments/RoomEnvironment.js';
import * as modelloader from '../loader'
import { OctreeManager, Box3Status, Node } from '../Octree/OctreeManager'
import { PlaneHit } from '../Octree/PlaneHit';
import { RayIntersection } from '../Octree/RayIntersection';
import  PSSceneManagement from '../PSSceneManagemant'

type modeType =  'translate' | 'rotate' | 'translate';

type pscommand = pixelstreamingCommand.addItemCommand
                | pixelstreamingCommand.cameraStatusCommand
                | pixelstreamingCommand.deleteItemCommand
                | pixelstreamingCommand.developCommand
                | pixelstreamingCommand.editItemCommand
                | pixelstreamingCommand.imagesizeCommand
                | pixelstreamingCommand.placeDateCommand
                | pixelstreamingCommand.sceneextrasCommand
                | pixelstreamingCommand.changematerialCommand
                | pixelstreamingCommand.autoexposureCommand
                | pixelstreamingCommand.lightSettingmCommand;

/* DevGlue
 * Develop用.
 */
export class WebCadDevelop extends Develop {
    private autoBase: marietta3d.AutoGen.AutoBase;

    private autoMain: marietta3d.manager.AutoMain;

    private get data(): marietta3d.AutoGen.AutoBase { return this.autoBase; }

    private get main(): marietta3d.manager.AutoMain { return this.autoMain; }

    // private streamingPlayer: network.player = null;

    constructor(threeView: ThreeView) {
      super(threeView);

      // 仮の連結.
      this.test3dev();
    }

    /* addDevelopMenu
     * 開発メニュー追加.
     */
    public get threeView(): ThreeView { return <ThreeView>(this.threeViewBase); }

    protected addDevelopMenus() {
        super.addDevelopMenus();

      $('#developMenus3D').append('<input type="button" class="webcadBtn for3D dev3d" id="house" value="house" /> ');
      if ($('#house').bind != undefined) {
        $('#house').bind('click', () => {
            this.threeView.wcItemmgr.houseObjects.visible = !this.threeView.wcItemmgr.houseObjects.visible;
        });
      }

      $('#developMenus3D').append('<input type="button" class="webcadBtn for3D dev3d" id="visibleObjects" value="visibleObjects" /> ');
      if ($('#visibleObjects').bind != undefined) {
        $('#visibleObjects').bind('click', () => {
            ThreeView.get().scene.me.traverse(object => object.visible = true);
        });
      }

      $('#developMenus3D').append('<input type="button" class="webcadBtn for3D dev3d" id="lightsTest" value="lightsTest" /> ');
      if ($('#lightsTest').bind != undefined) {
        $('#lightsTest').bind('click', () => {
          ThreeView.get().wcDevelop.setupLightsGui();
        });
      }

      $('#developMenus3D').append('<input type="button" class="webcadBtn for3D dev3d" id="AoriTest" value="AoriTest" /> ');
      if ($('#AoriTest').bind != undefined) {
        $('#AoriTest').bind('click', () => {
          ThreeView.get().wcDevelop.setupAoriGui();
        });
      }
      $('#developMenus3D').append('<input type="button" class="webcadBtn for3D dev3d" id="WtCam" value="WtCam" /> ');
      if ($('#WtCam').bind != undefined) {
        $('#WtCam').bind('click', () => {
          ThreeView.get().wcDevelop.setupWtCamGui();
        });
      }
      $('#developMenus3D').append('<input type="button" class="webcadBtn for3D dev3d" id="daytime" value="Day" /> ');
      if ($('#daytime').bind != undefined) {
        $('#daytime').bind('click', () => {
          ThreeView.get().toDayTime();
        });
      }
      $('#developMenus3D').append('<input type="button" class="webcadBtn for3D dev3d" id="nighttime" value="Night" /> ');
      if ($('#nighttime').bind != undefined) {
        $('#nighttime').bind('click', () => {
          ThreeView.get().toNightTime();
        });
      }
      $('#developMenus3D').append('<input type="button" class="webcadBtn for3D dev3d" id="imageReq" value="ImageReq" /> ');
      if ($('#imageReq').bind != undefined) {
        $('#imageReq').bind('click', () => {
          ThreeView.get().scene.me.traverse((obj) => {
            if((<THREE.Light>obj).isLight) {
              console.log(obj);
            }
          })
        });
      }
      $('#developMenus3D').append('<input type="button" class="webcadBtn for3D dev3d" id="wallColor" value="WallColor" /> ');
      if ($('#wallColor').bind != undefined) {
        $('#wallColor').bind('click', () => {
          ThreeView.get().wcDevelop.setupColorGui();
        });
      }
      $('#developMenus3D').append('<input type="button" class="webcadBtn for3D dev3d" id="shapeOnWall" value="ShapeOnWall" /> ');
      if ($('#shapeOnWall').bind != undefined) {
        $('#shapeOnWall').bind('click', () => {
          ThreeView.get().wcDevelop.setupShapeOnWall();
        });
      }
      $('#developMenus3D').append('<input type="button" class="webcadBtn for3D dev3d" id="textureToScreen" value="TextureToScreen" /> ');
      if ($('#textureToScreen').bind != undefined) {
        $('#textureToScreen').bind('click', () => {
          ThreeView.get().wcDevelop.setupTextureToScreen();
        });
      }
      $('#developMenus3D').append('<input type="button" class="webcadBtn for3D dev3d" id="addPointLight" value="addPointLight" /> ');
      if ($('#addPointLight').bind != undefined) {
          $('#addPointLight').bind('click', () => {
            ThreeView.get().wcDevelop.setupAddPointLight();
          });
      }
      $('#developMenus3D').append('<input type="button" class="webcadBtn for3D dev3d" id="vertexNormals" value="vertexNormals" /> ');
      if ($('#vertexNormals').bind != undefined) {
          $('#vertexNormals').bind('click', () => {
            ThreeView.get().wcDevelop.setupVertexNormals();
          });
      }
      $('#developMenus3D').append('<input type="button" class="webcadBtn for3D dev3d" id="Environment" value="Environment" /> ');
      if ($('#Environment').bind != undefined) {
          $('#Environment').bind('click', () => {
            ThreeView.get().wcDevelop.setupEnvironment();
          });
      }

      $('#developMenus3D').append('<input type="button" class="webcadBtn for3D dev3d" id="ExportZip" value="ExportZip" /> ');
      if ($('#ExportZip').bind != undefined) {
          $('#ExportZip').bind('click', () => {
            ThreeView.get().wcDevelop.setupExportZip();
          });
      }

      $('#developMenus3D').append('<input type="button" class="webcadBtn for3D dev3d" id="minimap" value="minimap" /> ');
      if ($('#minimap').bind != undefined) {
          $('#minimap').bind('click', () => {
            const minimap = document.getElementById('topview');
            if (minimap.style.visibility == 'hidden') {
                minimap.style.visibility = 'visible';
            } else {
                minimap.style.visibility = 'hidden';
            }
          });
      }

      $('#developMenus3D').append('<input type="button" class="webcadBtn for3D dev3d" id="InfoLog" value="InfoLog" /> ');
      if ($('#InfoLog').bind != undefined) {
          $('#InfoLog').bind('click', () => {
            ThreeView.get().wcDevelop.setupInfoLog();
          });
      }

      $('#developMenus3D').append('<input type="button" class="webcadBtn for3D dev3d" id="LaserPointer" value="LaserPointer" /> ');
      if ($('#LaserPointer').bind != undefined) {
          $('#LaserPointer').bind('click', () => {
            ThreeView.get().wcDevelop.laserPointer();
          });
      }

      $('#developMenus3D').append('<input type="button" class="webcadBtn for3D dev3d" id="PickUpData" value="PickUpData" /> ');
      if ($('#PickUpData').bind != undefined) {
          $('#PickUpData').bind('click', () => {
            ThreeView.get().wcDevelop.pickupData();
          });
      }

      $('#developMenus3D').append('<input type="button" class="webcadBtn for3D dev3d" id="SpacePlanning" value="SpacePlanning" /> ');
      if ($('#SpacePlanning').bind != undefined) {
          $('#SpacePlanning').bind('click', () => {
            ThreeView.get().wcDevelop.SpacePlanning();
          });
      }

      $('#developMenus3D').append('<input type="button" class="webcadBtn for3D dev3d" id="RayIntersection" value="RayIntersection" /> ');
      if ($('#RayIntersection').bind != undefined) {
          $('#RayIntersection').bind('click', () => {
            ThreeView.get().wcDevelop.Ray();
          });
      }

      $('#developMenus3D').append('<input type="button" class="webcadBtn for3D dev3d" id="PlaneHit" value="PlaneHit" /> ');
      if ($('#PlaneHit').bind != undefined) {
          $('#PlaneHit').bind('click', () => {
            ThreeView.get().wcDevelop.Plane();
          });
      }

      $('#developMenus3D').append('<input type="button" class="webcadBtn for3D dev3d" id="PickBox" value="PickBox" /> ');
      if ($('#PickBox').bind != undefined) {
          $('#PickBox').bind('click', () => {
            ThreeView.get().wcDevelop.setupPickBox();
          });
      }

      $('#developMenus3D').append('<input type="button" class="webcadBtn for3D dev3d" id="ServerCommand" value="ServerCommand" /> ');
      if ($('#ServerCommand').bind != undefined) {
          $('#ServerCommand').bind('click', () => {
            ThreeView.get().wcDevelop.setupServerCommand();
          });
      }

      if ($('.for3D').hide != undefined) $('.for3D').hide();
      if ($('.developMenus3D').show != undefined) $('#developMenus3D').show();
    }

    /* fileLoader
     * dae または json形式のファイル読み込み.
     */
    public picker: HTMLInputElement;

    /* animLoader
     * dae 形式のアニメーションファイル読み込み.
     */
    public animPicker: HTMLInputElement;

    /* test3dev
     * テスト.
     */
    private test3dev() {
      if ($('#test3dev').bind != undefined) {
        $('#test3dev').bind('click', () => {
          const messages: string[] = [];
          messages.push('テストメッセージ');
          messages.push('WebCad不動産');
          const subtexts: string[] = [];
          subtexts.push('猛犬注意!!');
          subtexts.push('これより先には入らないで!!');
          ThreeView.get().itemmgr.createMessage(MessageType.Alert, messages, subtexts);
          ThreeView.get().itemmgr.showMessage();
        });
      }
    }

    private _lights: any;

    private _lightHelpers: THREE.Group;

    public setupGui() {
      super.setupGui();
    }

    public removeHelpers(): void {
      if (this._lightHelpers != undefined) {
        ThreeView.get().scene.remove(this._lightHelpers);
        this._lightHelpers = undefined;
      }
    }

    public addHelpers(lights: THREE.Light[]): void {
      if (this._lightHelpers == undefined) {
        this._lightHelpers = new THREE.Group();
        for (let i = 0; i < lights.length; i++) {
          if (lights[i] instanceof THREE.DirectionalLight) {
            const dLight = <THREE.DirectionalLight>(lights[i]);
            const dhelper = new THREE.DirectionalLightHelper(dLight);
            this._lightHelpers.add(dhelper);
          } else if (lights[i] instanceof THREE.SpotLight) {
            const sLight = <THREE.SpotLight>(lights[i]);
            const shelper = new THREE.SpotLightHelper(sLight);
            this._lightHelpers.add(shelper);
          } else if (lights[i] instanceof THREE.PointLight) {
            const pLight = <THREE.PointLight>(lights[i]);
            const phelper = new THREE.PointLightHelper(pLight, 1);
            this._lightHelpers.add(phelper);
          }
        }
        ThreeView.get().scene.me.add(this._lightHelpers);
      }
    }

    public removeControllers(gui: any) {
      for (let i = gui.__controllers.length - 1; i >= 0; i--) {
        gui.remove(gui.__controllers[i]);
      }
      gui.__controllers = [];
    }

    public removeGuiChild(gui: GUI): boolean {
      // public removeGuiChild(gui: dat.GUI): boolean {
      let clearOld: boolean = false;
      this.removeControllers(gui);
      for (const key in gui.__folders) {
        const subGui = gui.__folders[key];
        this.removeControllers(subGui);
        this.removeGuiChild(subGui);

        subGui.close();
        gui.__ul.removeChild(subGui.domElement.parentNode);
        // delete subGui;
        clearOld = true;
      }
      gui.onResize();
      gui.__folders = {};

      return clearOld;
    }

    private _aori: any;

    public setupAoriGui(): void {
      if (this.gui != undefined) {
        const clearOld = this.removeGuiChild(this.gui);
        this.removeHelpers();
        if (clearOld) return;
      }
      super.setupGui();
      this._aori = {};
      this._aori.ratio = webcadDefines.WebCadCameraDefs.wtAoriFixRatio;
      this.gui.add(this._aori, 'ratio', -5, 5).onChange(() => { this.setAoriValue(); });
    }

    public setAoriValue() {
      webcadDefines.WebCadCameraDefs.wtAoriFixRatio = this._aori.ratio;
      const wtCam: any = ThreeView.get().wcCameras.getCamera(defines.CameraDefs.wlkthCamNo);
      wtCam.me.updateProjectionMatrix();
    }

    private _wtCam: any;

    public setupWtCamGui(): void {
      if (this.gui != undefined) {
        const clearOld = this.removeGuiChild(this.gui);
        this.removeHelpers();
        if (clearOld) return;
      }
      super.setupGui();

      this._wtCam = {};
      const wtCam: any = ThreeView.get().wcCameras.getCamera(defines.CameraDefs.wlkthCamNo);
      if (wtCam) {
        this._wtCam.fov = wtCam.me.fov;
        this._wtCam.aspect = wtCam.me.aspect;
        this._wtCam.near = wtCam.me.near;
        this._wtCam.far = wtCam.me.far;

        this.gui.add(this._wtCam, 'fov', 10, 100).onChange(() => { this.setWtCamValue(); });
        this.gui.add(this._wtCam, 'aspect', 0, 2).onChange(() => { this.setWtCamValue(); });
        this.gui.add(this._wtCam, 'near', 0, 5).onChange(() => { this.setWtCamValue(); });
        this.gui.add(this._wtCam, 'far', 0, 1000).onChange(() => { this.setWtCamValue(); });
        this.gui.open();
      }
    }

    public setWtCamValue(): void {
      const wtCam: any = ThreeView.get().wcCameras.getCamera(defines.CameraDefs.wlkthCamNo);
      if (wtCam) {
        wtCam.me.fov = this._wtCam.fov;
        wtCam.me.aspect = this._wtCam.aspect;
        wtCam.me.near = this._wtCam.near;
        wtCam.me.far = this._wtCam.far;
        wtCam.me.updateProjectionMatrix();
      }
    }

    public setupLightsGui(): void {
      if (this.gui != undefined) {
        const clearOld = this.removeGuiChild(this.gui);
        this.removeHelpers();
        if (clearOld) return;
      }
      super.setupGui();

      this._lights = {};
      this._lights.dummy1 = '';
      this._lights.dummy2 = '';
      this._lights.dummy3 = '';
      this.gui.add(this._lights, 'dummy1').onChange(() => { this.setLightValue(); });
      this.gui.add(this._lights, 'dummy2').onChange(() => { this.setLightValue(); });
      this.gui.add(this._lights, 'dummy3').onChange(() => { this.setLightValue(); });

      this._lights.night = false;
      this.gui.add(this._lights, 'night', false).onChange(() => { this.setLightValue(); });
      this._lights.lighthelper = false;
      this.gui.add(this._lights, 'lighthelper', false).onChange(() => { this.setLightValue(); });

      this._lights.turbidity = ThreeView.get().scene.environment.sky.me.uniforms.turbidity.value;
      this._lights.rayleigh = ThreeView.get().scene.environment.sky.me.uniforms.rayleigh.value;
      this._lights.luminance = ThreeView.get().scene.environment.sky.me.uniforms.luminance.value;
      this._lights.mieCoefficient = ThreeView.get().scene.environment.sky.me.uniforms.mieCoefficient.value;
      this._lights.mieDirectionalG = ThreeView.get().scene.environment.sky.me.uniforms.mieDirectionalG.value;
      this._lights.sunDiskIntensity = ThreeView.get().scene.environment.sky.me.uniforms.sunDiskIntensity.value;

      this._lights.inclination = ThreeView.get().scene.environment.sky.param.inclination;
      this._lights.azimuth = ThreeView.get().scene.environment.sky.param.azimuth;

      this.gui.add(this._lights, 'turbidity', 0, 1).onChange(() => { this.setLightValue(); });
      this.gui.add(this._lights, 'rayleigh', 0, 1).onChange(() => { this.setLightValue(); });
      this.gui.add(this._lights, 'luminance', 0, 1).onChange(() => { this.setLightValue(); });
      this.gui.add(this._lights, 'mieCoefficient', 0, 1).onChange(() => { this.setLightValue(); });
      this.gui.add(this._lights, 'mieDirectionalG', 0, 1).onChange(() => { this.setLightValue(); });
      this.gui.add(this._lights, 'sunDiskIntensity', 0, 1).onChange(() => { this.setLightValue(); });

      this.gui.add(this._lights, 'inclination', 0, 1).onChange(() => { this.setLightValue(); });
      this.gui.add(this._lights, 'azimuth', 0, 1).onChange(() => { this.setLightValue(); });

      const ligs = ThreeView.get().wcItemmgr.lights.lights;
      for (const key in ligs) {
        const lights = ligs[key];
        for (let i = 0; i < lights.length; i++) {
          this._lights[key + String(i)] = lights[i].intensity;
          this.gui.add(this._lights, key + String(i), 0, 10).onChange(() => { this.setLightValue(); });
          if (lights[i] instanceof THREE.DirectionalLight) {
            const dlight = <THREE.DirectionalLight>(lights[i]);
            const folder = this.gui.addFolder(`${key + String(i)}-params`);
            this._lights[`${key}-color-${String(i)}`] = `#${dlight.color.getHexString()}`;
            folder.addColor(this._lights, `${key}-color-${String(i)}`).onChange(() => { this.setLightValue(); });
          } else if (lights[i] instanceof THREE.AmbientLight) {
            const alight = <THREE.AmbientLight>(lights[i]);
            const folder = this.gui.addFolder(`${key + String(i)}-params`);
            this._lights[`${key}-color-${String(i)}`] = `#${alight.color.getHexString()}`;
            folder.addColor(this._lights, `${key}-color-${String(i)}`).onChange(() => { this.setLightValue(); });
          }
        }
      }
      this.gui.open();
    }

    public setLightValue(): void {
      ThreeView.get().scene.environment.night = this._lights.night;

      const param = new SkyParam();

      param.turbidity = this._lights.turbidity;
      param.rayleigh = this._lights.rayleigh;
      param.luminance = this._lights.luminance;
      param.mieCoefficient = this._lights.mieCoefficient;
      param.mieDirectionalG = this._lights.mieDirectionalG;
      param.sunDiskIntensity = this._lights.sunDiskIntensity;

      param.inclination = this._lights.inclination;
      param.azimuth = this._lights.azimuth;
      ThreeView.get().scene.environment.sky.param = param;

      const ligs = ThreeView.get().wcItemmgr.lights.lights;
      let lights;
      for (const key in ligs) {
        lights = ligs[key];
        for (let i = 0; i < lights.length; i++) {
          lights[i].intensity = this._lights[key + String(i)];
          if (lights[i] instanceof THREE.DirectionalLight) {
            const dlight = <THREE.DirectionalLight>(lights[i]);
            dlight.color = new THREE.Color(this._lights[`${key}-color-${String(i)}`]);
          } else if (lights[i] instanceof THREE.AmbientLight) {
            const alight = <THREE.AmbientLight>(lights[i]);
            alight.color = new THREE.Color(this._lights[`${key}-color-${String(i)}`]);
          }
        }
      }
      this.removeHelpers();
      if (this._lights.lighthelper) this.addHelpers(lights);
    }

    private changeColor: string;

    public setupColorGui(): void {
      if (this.ColorGui != undefined) {
        const clearOld = this.removeGuiChild(this.ColorGui);
        this.removeHelpers();
        if (clearOld) return;
      }

      super.setupColorGui();

      const colorFormats = {
        string: '#ff0000',
        int: 0xffffff,
        object: { r: 1, g: 1, b: 1 },
        array: [ 1, 1, 1 ]
      };


      this.ColorGui.addColor( colorFormats, 'string' ).onChange((value) => {
        this.changeColor = value;
      });

      this.ColorGui.open();

      const wallTargets = [];

      this.threeView.wcItemmgr.houseObjects.traverse((object: THREE.Object3D) => {
        if (object.name && object.name.match(/^rom.*-(wall|kosi)-node/)) {
          wallTargets.push(object);
        }
      });

      const findkosiNode = (name: string): THREE.Object3D => {
        return this.threeView.wcItemmgr.houseObjects.getObjectByName(name.replace('wall', 'kosi'));
      }
      const findwallNode = (name: string): THREE.Object3D => {
        return this.threeView.wcItemmgr.houseObjects.getObjectByName(name.replace('kosi', 'wall'));
      }

      const kosi = (name: string): boolean => {
        return name.match(/^rom.*-kosi-node/) != null;
      }
      const wall = (name: string): boolean => {
        return name.match(/^rom.*-wall-node/) != null;
      }

      const initRayCaster = new THREE.Raycaster();

      // raycaster wall 拾えたら、そこの色を変える
      this.threeView.container.addEventListener('click', (e: MouseEvent) => {
        const element = e.currentTarget as HTMLElement;
        // canvas要素上のXY座標
        // canvas要素の幅・高さ
        const rect = element.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const w = rect.width;
        const h = rect.height;

        // -1〜+1の範囲で現在のマウス座標を登録する
        const pointer = new THREE.Vector2();
        pointer.x = (x / w) * 2 - 1;
        pointer.y = -(y / h) * 2 + 1;

        initRayCaster.setFromCamera(pointer, this.threeView.wcCameras.camera.me);
        const hitObj = initRayCaster.intersectObjects(wallTargets, true);

        if (hitObj.length > 0) {
          const mesh = <THREE.Mesh>hitObj[0].object;
          if(mesh.isMesh) {

            if  (Array.isArray(mesh.material)) {
              ;
            } else {
              const material = new THREE.MeshStandardMaterial();
              material.color.set(this.changeColor);
              material.map = null;
              material.needsUpdate = true;
              mesh.material = material;

              const find = wall(mesh.name) ? findkosiNode : findwallNode;

              const object =  <THREE.Mesh>find(mesh.name);
              object.material = material;
            }
          }
        }
      });
    }

    private setupShapeOnWall(): void {
      // guiが存在していたら削除
      if (this.PlaceGui != undefined) {
        const clearOld = this.removeGuiChild(this.PlaceGui);
        this.removeHelpers();
        if (clearOld) return;
      }
      super.setupPlace();

      const transFormControls = new TransformControls(this.threeView.wcCameras.camera.me, this.threeView.container);
      transFormControls.space = 'local';
      transFormControls.showZ = false;
      this.threeView.wcScene.me.add(transFormControls);
      transFormControls.addEventListener('dragging-changed', (e: THREE.Event) => {
        const wrkth = this.threeView.wcCameras.getCamera(defines.CameraDefs.wlkthCamNo);
        const control = <WalkThroughCameraControl>wrkth.control;
        control._instance.setEnabled(!e.value);
        console.log(`dragging-changed`);
      });

      let obj: THREE.Object3D;
      let box: THREE.Box3;
      let center: THREE.Vector3;
      let group: THREE.Group;
      const onLoad = (glb: modelloader.ObjectType) => {
        obj = glb.scene;
        box = new THREE.Box3().setFromObject(obj);
        center = box.getCenter(new THREE.Vector3());
        obj.position.setZ(obj.position.z - box.min.z);
        group = new THREE.Group();
        group.add(obj);
        this.threeView.wcItemmgr.addOtherShapes(group);
        group.visible = false;
        console.log('形状配置完了');
      }

      const clockSet = () => {
        // 形状読み込み
        const url = './3d/item/test_item/SM_Clock.glb';
        new modelloader.Loader(url).getLoader().loadAsync(url).then((glb: modelloader.ObjectType) => {
          return new Promise((resolve, rejected) => {
            resolve(onLoad(glb));
          }).then(() => {
            // 配置・移動
            this.threeView.container.addEventListener('mousedown', (e: MouseEvent) => setClock(e));
          });
        });
      }

      const set = () => {
        const url = './3d/item/test_item/air_conditioner.glb';
        new modelloader.Loader(url).getLoader().loadAsync(url).then((glb: modelloader.ObjectType) => {
          return new Promise((resolve, rejected) => {
            resolve(onLoad(glb));
          }).then(() => {
            this.threeView.container.addEventListener('mousedown', (e: MouseEvent) => setClock(e));
          });
        });
      }

      const clock = {
        '時計配置' : clockSet,
        'エアコン配置' : set
      }
      this.PlaceGui.add(clock, '時計配置');
      this.PlaceGui.add(clock, 'エアコン配置');

      // 壁情報まとめて取得
      const wallTargets = [];

      const traverse_test = (objects: THREE.Object3D) => {
        console.group();
        for (let i = 0; i < objects.children.length; i++) {
          const object = objects.children[i];
          console.log(object);
          traverse_test(object);
        }
        console.groupEnd();
      }
      traverse_test(this.threeView.wcItemmgr.houseObjects);

      // this.threeView.wcItemmgr.houseObjects.children.forEach((object) => {
      //   if (object.name && object.name.match(/^rom.*-wall-node/)) {
      //     wallTargets.push(object);
      //   }
      // });

      this.threeView.wcItemmgr.houseObjects.traverse((object: THREE.Object3D) => {
        if (object.name && object.name.match(/^rom.*-wall-node/)) {
          wallTargets.push(object);
        }
      });

      const pointer = (e: MouseEvent) => {
        const element = e.currentTarget as HTMLElement;
        // canvas要素上のXY座標
        // canvas要素の幅・高さ
        const rect = element.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const w = rect.width;
        const h = rect.height;

        // -1〜+1の範囲で現在のマウス座標を登録する
        const pointer = new THREE.Vector2();
        pointer.x = (x / w) * 2 - 1;
        pointer.y = -(y / h) * 2 + 1;
        return pointer;
      }

      const initRayCaster = new THREE.Raycaster();
      const setClock = (e: MouseEvent) => {
        group.visible = true;

        initRayCaster.setFromCamera(pointer(e), this.threeView.wcCameras.camera.me);
        const hitObj = initRayCaster.intersectObjects(wallTargets, true);

        if (hitObj.length <= 0) return;

        // ヒットした壁を取得
        const mesh = <THREE.Mesh>hitObj[0].object;
        if(!mesh.isMesh) return;

        // 壁の法線ベクトル
        const normal = hitObj[0].face.normal;

        // 配置オブジェクトの正のz軸ベクトル
        const ObjZAxis = group.getWorldDirection(new THREE.Vector3()).normalize();
        console.log('ObjZAxis', ObjZAxis);

        // 回転角rad取得
        const rad = ObjZAxis.angleTo(normal);

        // 回転軸を取得
        const axisRotation = ObjZAxis.cross(normal).normalize();

        // 配置オブジェクトのQuaternionを取得
        const quaternion = group.quaternion;

        // 回転させるためのQuaternionを作成
        const target = new THREE.Quaternion();
        target.setFromAxisAngle(axisRotation, rad);

        // 配置オブジェクトの回転
        quaternion.multiply(target);


        // クリックした位置にオブジェクトを配置
        const pos = hitObj[0].point;
        group.position.set(pos.x, pos.y - center.y, pos.z);

        transFormControls.setSize(1);
        transFormControls.attach(group);
      }
    }

    // ピクセルストリーミング画像表示検証
    private setupTextureToScreen() {
      // コンポーザーを作成
      const composer = new EffectComposer(ThreeView.get().renderer.me);
      // ビデオテクスチャーを読み込み
      const video = <HTMLVideoElement>document.createElement('video');
      video.src = './3d/item/test_item/videoTexture.mp4';
      video.load();
      video.play();
      const texture = new THREE.VideoTexture(video);

      let width: number;
      let height: number;
      video.addEventListener('loadedmetadata', (event) => {
        // ビデオの縦横
        width = (<HTMLVideoElement>event.currentTarget).videoWidth;
        height = (<HTMLVideoElement>event.currentTarget).videoHeight;
      });

      const textureEffect = new TexturePass(texture);
      textureEffect.renderToScreen = true;
      composer.addPass(textureEffect);

      const animate = () => {
        window.requestAnimationFrame(animate);
        composer.render();
      }
      animate();

    }

    private createTransFormControls() {
      const transFormControls = new TransformControls(this.threeView.wcCameras.camera.me, this.threeView.container);
      transFormControls.space = 'local';
      this.threeView.wcScene.me.add(transFormControls);

      transFormControls.addEventListener('dragging-changed', (e: THREE.Event) => {
        const orbitCamera = this.threeView.wcCameras.getCamera(defines.CameraDefs.orbitCamNo);
        const control = <OrbitCameraControl>orbitCamera.control;
        control._instance.enabled = !e.value;
        console.log(`dragging-changed`);
      });

      return transFormControls;
    }

      // テクスチャ確認のため、ライト追加
      public setupAddPointLight() {
        // guiが存在していたら削除
        if (this.LightGui != undefined) {
        const clearOld = this.removeGuiChild(this.LightGui);
        this.removeHelpers();
        if (clearOld) return;
        }
        super.setupLight();

        // 移動controlを作成
        const transFormControls = this.createTransFormControls();
        const pointLights = [];
        let count = 1;
        const add = () => {
          const pointLight = new THREE.PointLight();
          pointLights.push(pointLight);
          ThreeView.get().scene.me.add(pointLight);

          const sphereSize = 1;
          const pointLightHelper = new THREE.PointLightHelper( pointLight, sphereSize );
          pointLights.push(pointLightHelper);
          ThreeView.get().scene.me.add( pointLightHelper );

          const folder = this.LightGui.addFolder(`light${count}`);
          const formats = {
            string: '#ff0000',
            intensity: 1
          };
          folder.addColor( formats, 'string' ).onChange((value) => {
            pointLight.color = new THREE.Color(value);
          });
          // 光の強度 pointLight 強度 4π * intensity
          folder.add(formats, 'intensity', 0, 1).onChange(() => {
            pointLight.intensity = formats.intensity;
          });

          transFormControls.attach(pointLight);
          count += 1;
        }

        const change = () => {
          pointLights.forEach((pointLight) => {
          pointLight.visible = !pointLight.visible;
          });
          transFormControls.visible = !transFormControls.visible;
        }

        const light = {
          'ライト追加' : add,
          'ON/OFF' : change
        }
        this.LightGui.add(light, 'ライト追加');
        this.LightGui.add(light, 'ON/OFF');
      }

      public setupVertexNormals() {
        const binaryData = ThreeView.get().wcItemmgr.BinaryData;
        new modelloader.GLTFHouseLoader().loadAsync(binaryData).then((glb) => {
          // @ts-ignore
          const objects = glb.scene;
          objects.traverse((obj) => {
            const mesh = <THREE.Mesh>obj;
            if (!(mesh.isMesh)) return;
            mesh.geometry.computeVertexNormals();
            const helper = new VertexNormalsHelper(mesh, 2, 0x00ff00);
            ThreeView.get().wcItemmgr.scene.me.add(helper);
          });
        });
      }

      public setupEnvironment() {
        // guiが存在していたら削除
        if (this.EnvironmentGui_ != undefined) {
        const clearOld = this.removeGuiChild(this.EnvironmentGui_);
        this.removeHelpers();
        if (clearOld) return;
        }
        super.setupEnvironment();

        let environment = new HDREnvironment();
        let sky: Sky;
        const changeSky = (path: string) => {
          sky = new Sky();
          sky.apply(ThreeView.get().wcScene);
          ThreeView.get().wcScene.wcEnvironment.clouds.apply(ThreeView.get().wcScene);
          environment.reset(ThreeView.get().wcScene);
          ThreeView.get().scene.environment.sky = sky;
        }
        const changeNeutral = (path: string) => {
            ThreeView.get().wcScene.wcEnvironment.sky.reset(ThreeView.get().wcScene);
            ThreeView.get().wcScene.wcEnvironment.clouds.reset(ThreeView.get().wcScene);
            sky?.reset(ThreeView.get().wcScene);
            environment.reset(ThreeView.get().wcScene);
            environment.applyScene(ThreeView.get().wcScene, new RoomEnvironment());

            sky = new Sky();
            sky.apply(ThreeView.get().wcScene);
            ThreeView.get().wcScene.wcEnvironment.clouds.apply(ThreeView.get().wcScene);
            ThreeView.get().scene.environment.sky = sky;
        }

        const changeHDRE = (path: string) => {
          ThreeView.get().wcScene.wcEnvironment.sky.reset(ThreeView.get().wcScene);
          ThreeView.get().wcScene.wcEnvironment.clouds.reset(ThreeView.get().wcScene);
          sky?.reset(ThreeView.get().wcScene);
          environment.reset(ThreeView.get().wcScene);
          environment.apply(ThreeView.get().wcScene, path);
            {
                sky = new Sky();
                ThreeView.get().scene.environment.sky = sky;
            }
        }

        const environments = [
          {
            'name': 'Sky',
            'path': '',
            'generater': changeSky
          },
          {
            'name': 'neutral',
            'path': '',
            'generater': changeNeutral
          },
          {
            'name': 'HDRE1',
            'path': './3d/item/test_item/environment_1.hdr',
            'generater': changeHDRE
          },
          {
            'name': 'HDRE2',
            'path': './3d/item/test_item/environment_2.hdr',
            'generater': changeHDRE
          }
        ];

        const formats = {
          environment: 'Sky',
          exposure: 1.0
        }

        const names = environments.map(val => val.name);
        this.EnvironmentGui_.add(formats, 'environment', names).onChange((value) => {
          const object = environments.find(val => val.name == value);
          object.generater(object.path);
        });
        this.EnvironmentGui_.add( formats, 'exposure', 0, 10, 0.01 ).onChange((value) => {
            const renderer = ThreeView.get().wcRenderer._instance;
            renderer.toneMapping = THREE.ACESFilmicToneMapping;
            renderer.toneMappingExposure = value;
        });
      }

      public setupExportZip() {
        const download = (buffer, fileType, filename) => {
          const link = document.createElement( 'a' );
          link.style.display = 'none';
          document.body.appendChild( link ); // Firefox workaround, see #6594

          const save = ( blob, filename ) => {
              link.href = URL.createObjectURL( blob );
              link.download = filename;
              link.click();
          }
          save(new Blob([buffer], {type: fileType}), filename);
        }

        const filename = 'glbCompress.glb';
        new ZipCompression(ThreeView.get().wcItemmgr.BinaryData, filename)
          .compress()
          .then((data: Uint8Array) => {
            // ダウンロード
            download(data.buffer, 'application/zip', 'tatemono.zip');
          });
      }

      public setupInfoLog() {
        const info = ThreeView.get().wcRenderer.me.info.render;
        console.log('draw calls : ', info.calls);
        console.log('triangles : ', info.triangles);
        console.log('points : ', info.points);
        console.log('lines : ', info.lines);
      }

      public laserPointer() {
        const camera = <THREE.PerspectiveCamera>ThreeView.get().cameras.camera.me;

        const helper = new THREE.CameraHelper( camera );
        ThreeView.get().scene.me.add( helper );

        const point = camera.getWorldPosition(new THREE.Vector3());

        const ray = new THREE.Raycaster();

        const wallTargets = [];

        this.threeView.wcItemmgr.houseObjects.traverse((object: THREE.Object3D) => {
            if (object.name && object.name.match(/^rom.*-(wall|kosi)-node/)) {
            wallTargets.push(object);
            }
        });
        //カメラ正面０度の位置
        camera.updateMatrixWorld();

        const rotationMatrix = new THREE.Matrix4().extractRotation(camera.matrixWorld);

        const worldUp = new THREE.Vector3(0, 1, 0).applyMatrix4(rotationMatrix).normalize();
        const worldLeft = new THREE.Vector3(1, 0, 0).applyMatrix4(rotationMatrix).normalize();

        const yup = new THREE.Vector3(0, 1, 0);
        const zVector = camera.getWorldDirection(new THREE.Vector3()).projectOnPlane(yup).normalize();

        ray.set(point, zVector);
        {
            const hitObj = ray.intersectObjects([ThreeView.get().wcItemmgr.houseObjects], true);

            if (hitObj.length > 0) {
                const point = hitObj[0].point;

                const geometry = new THREE.SphereGeometry( 0.03, 32, 16 );
                const material = new THREE.MeshBasicMaterial( { color: 0xff0000 } );
                const sphere = new THREE.Mesh( geometry, material );
                sphere.position.set(point.x, point.y, point.z)
                ThreeView.get().wcScene.me.add( sphere );
            }
        }


        //
        zVector.applyAxisAngle(worldLeft, THREE.MathUtils.degToRad(60));    // 正面より６０度の方向
        ray.set(point, zVector);
        {
            const hitObj = ray.intersectObjects([ThreeView.get().wcItemmgr.houseObjects], true);

            if (hitObj.length > 0) {
                const point = hitObj[0].point;

                const geometry = new THREE.SphereGeometry( 0.03, 32, 16 );
                const material = new THREE.MeshBasicMaterial( { color: 0x0000ff } );
                const sphere = new THREE.Mesh( geometry, material );
                sphere.position.set(point.x, point.y, point.z)
                ThreeView.get().wcScene.me.add( sphere );
            }
        }

      }

      // クリックしたときに、オブジェクトが何か取得できる
      public pickupData() {
        const pointer = (e: MouseEvent) => {
          const element = e.currentTarget as HTMLElement;
          // canvas要素上のXY座標
          // canvas要素の幅・高さ
            const rect = element.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;
            const w = rect.width;
            const h = rect.height;

          // -1〜+1の範囲で現在のマウス座標を登録する
          const pointer = new THREE.Vector2();
          pointer.x = (x / w) * 2 - 1;
          pointer.y = -(y / h) * 2 + 1;
          return pointer;
        }

        this.threeView.container.addEventListener('click', (e: MouseEvent) => pickup(e));

        const initRayCaster = new THREE.Raycaster();
        const group: THREE.Mesh[] = [];
        ThreeView.get().wcScene.me.traverse((object: THREE.Object3D) => {
          const mesh = <THREE.Mesh>object;
          if (!mesh.isMesh) return;
          group.push(mesh);
        });
        const pickup = (e: MouseEvent) => {
          initRayCaster.setFromCamera(pointer(e), this.threeView.wcCameras.camera.me);
          const hitObj = initRayCaster.intersectObjects(group, true);

          if (hitObj.length <= 0) return;

          console.log(hitObj[0].object);
        }
      }

      public setupPickBox() {

        const pickup = (e) => {

          const helper = new THREE.CameraHelper( ThreeView.get().wcCameras.camera.me );
          ThreeView.get().wcItemmgr.addOtherShapes(helper);

          const searchBox = (_status: Node, _pos: THREE.Vector3) => {
            if (_status.box.containsPoint(_pos)) {
              ThreeView.get().wcItemmgr.addOtherShapes(new THREE.Box3Helper(_status.box));
              if (_status.children && _status.children.length > 0) {
                for (let i = 0; i < _status.children.length; i++) {
                  searchBox(_status.children[i], _pos);
                }
              }
              else {
                return;
              }
            } else {
              return;
            }
          }

          const status = ThreeView.get().OctreeManager.nodeStatus;
          const pos = ThreeView.get().wcCameras.camera.me.getWorldPosition(new THREE.Vector3());
          searchBox(status, pos);

        }

        this.threeView.container.addEventListener('click', (e: MouseEvent) => pickup(e));

      }

      public setupServerCommand(): void {
        // guiが存在していたら削除
        if (this.ServerCommandGUI != undefined) {
            const clearOld = this.removeGuiChild(this.ServerCommandGUI);
            this.removeHelpers();
            if (clearOld) return;
        }
        super.setupServerCommand();

        const sendObject = (object: pscommand) => {
            ThreeView.get().pscommunication.send(object);
        }

        const sendglb = () => {
            const glb = new pixelstreamingCommand.GLB(ThreeView.get().wcItemmgr.BinaryData);

            const datas = glb.object();

            datas.forEach((data) => {
                console.log(`send GLB ${data}`);
                ThreeView.get().pscommunication.send(data);
            });
        }

        // const localtime = () => {
        //     const daytime = new pixelstreamingCommand.placeDateStatus();
        //     daytime.setDate(`2022/10/01 ${time}:00`);
        //     sendObject(daytime.object());
        // }

        const getImage = () => {
            ThreeView.get().PSImageView.showHideCanvas(true);
            new PSSceneManagement().getImage();
        }

        const createScene = () => {
            new PSSceneManagement().createScene();

            // const GLBData = ThreeView.get().wcItemmgr.BinaryData;
            // const extras = ThreeView.get().wcItemmgr.GltfExtras;

            // const camera = <THREE.PerspectiveCamera>ThreeView.get().wcCameras.camera.me;
            // const cameraCommand = new pixelstreamingCommand.cameraStatus(camera, ThreeView.get().wcCameras.isWalkThroughCameraMode());

            // ThreeView.get().pscommunication.createScene(GLBData, extras, cameraCommand);
        };

        // let time = 12;
        const commands = {
            'R2M': true,
            'Status': false,
            'Connect': () => ThreeView.get().pscommunication.serverAccess(),
            'WS Connect': () => ThreeView.get().pscommunication.wsAccess(),
            'GLB': sendglb,
            'Extras': () => sendObject(new pixelstreamingCommand.sceneextras(ThreeView.get().wcItemmgr.GltfExtras).object()) ,
            'CreateScene': () => createScene(),
            'Time': 12,
            'Light intensity': 0.5,
            'Temperature': 6500,
            // 'Local Time': localtime,
            'Auto Exposure': 10,
            'image': () => getImage(),
            // 'Freeze': () => sendObject(new pixelstreamingCommand.develop('freeze').object()),
            // 'UnFreeze': () => sendObject(new pixelstreamingCommand.develop('unfreeze').object()),
            'Reset': () => sendObject(new pixelstreamingCommand.develop('reset').object()),
            'Quit':  () => sendObject(new pixelstreamingCommand.develop('quit').object()),
            'Disconnect': () => ThreeView.get().pscommunication.disconnect(),
        }

        this.ServerCommandGUI.add(commands, 'R2M').onChange( value => {
            ThreeView.get().setPSServer(value);
        });
        this.ServerCommandGUI.add(commands, 'Status').onChange(value => {
            const PSS = document.getElementById('pixelStreamingStatus');
            if(PSS) {
                PSS.style.display = value ? 'block' : 'none';
            }
        });
        this.ServerCommandGUI.add(commands, 'Connect');
        this.ServerCommandGUI.add(commands, 'WS Connect');

        this.ServerCommandGUI.add(commands, 'GLB');
        this.ServerCommandGUI.add(commands, 'Extras');
        this.ServerCommandGUI.add(commands, 'CreateScene');
        this.ServerCommandGUI.add( commands, 'Time', 5, 22, 1 ).onChange( value => {
            const daytime = new pixelstreamingCommand.placeDateStatus();
            daytime.setDate(`2022/10/01 ${value}:00`);
            sendObject(daytime.object());
        });
        let intensity = 0.5;
        let temperature = 6500;
        this.ServerCommandGUI.add(commands, 'Light intensity', 0, 1, 0.1).onChange( (value) => {
            intensity = value;
            sendObject(new pixelstreamingCommand.lightSetting().object());
        });
        this.ServerCommandGUI.add(commands, 'Temperature', 2000, 8000, 100).onChange( (value) => {
            temperature = value;
            sendObject(new pixelstreamingCommand.lightSetting().object());
        });

        this.ServerCommandGUI.add(commands, 'Auto Exposure', 0, 15, 1).onChange( value => {
            sendObject(new pixelstreamingCommand.autoexposure(value).object());
        });

        this.ServerCommandGUI.add(commands, 'image');
        // this.ServerCommandGUI.add(commands, 'Freeze');
        // this.ServerCommandGUI.add(commands, 'UnFreeze');
        this.ServerCommandGUI.add(commands, 'Reset');
        this.ServerCommandGUI.add(commands, 'Quit');
        this.ServerCommandGUI.add(commands, 'Disconnect');
      }

      private findObject(box: THREE.Box3, node: Node): Box3Status[] {
        const intersection = box.intersectsBox(node.box);
        if (!intersection) {
          return [];
        }
        if (node.children.length == 0) {
          return node.box3Status;
        }
        let _box3Status: Box3Status[] = [];
        for(let i = 0; i < node.children.length; i++) {
          _box3Status = [..._box3Status, ...this.findObject(box, node.children[i])];
        }
        return _box3Status;
      }

      public SpacePlanning() {
        const getAllData = () => {
          const array = [];
          ThreeView.get().wcItemmgr.houseObjects.traverse((obj: THREE.Object3D) => {
              const mesh = <THREE.Mesh>obj;
              if (!mesh.isMesh) return;
              array.push(mesh);
          });
          array.push(...ThreeView.get().wcItemmgr.furnitureObjects);
          return array;
        }

        const objects = getAllData();

        const bvh = new OctreeManager(objects);

        const nodes = bvh.nodeStatus;

        for(let i = 0; i < objects.length; i++) {
          const object = objects[i];

          const box = new THREE.Box3().setFromObject(object);

          const match = [...new Set( this.findObject(box, nodes))];
          const matchObjects = match.filter(obj => {
            return obj.box.intersectsBox(box);
          });
          let flag = false;
          for(let j = 0; j < matchObjects.length; j++) {
            if( matchObjects[j].object.uuid == object.uuid) {
              flag = true;
              break;
            }
          }

          if (flag == false) {
            console.log(object);
          }
        }

      }

      private pointer (e: MouseEvent) {
        const element = e.currentTarget as HTMLElement;
        // canvas要素上のXY座標
        // canvas要素の幅・高さ
        const rect = element.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const w = rect.width;
        const h = rect.height;

        // -1〜+1の範囲で現在のマウス座標を登録する
        const _pointer = new THREE.Vector2();
        _pointer.x = (x / w) * 2 - 1;
        _pointer.y = -(y / h) * 2 + 1;
        return _pointer;
      }

      public Ray() {
        ThreeView.get().wcRenderer.me.domElement.addEventListener('click', (e: MouseEvent) => {
          const rayCaster = new THREE.Raycaster();
          rayCaster.setFromCamera(this.pointer(e), ThreeView.get().wcCameras.camera.me);

          const t0 = performance.now();
          for (let i = 0; i < 10000; i++) {
            new RayIntersection(rayCaster).getTargets(ThreeView.get().OctreeManager);
          }
          const t1 = performance.now();

          console.log(`Call to doSomething took ${t1 - t0} milliseconds.`);
        });
      }

      public Plane() {

        ThreeView.get().wcRenderer.me.domElement.addEventListener('click', (e: MouseEvent) => {
          // レイの当たり判定
          const rayCaster = new THREE.Raycaster();
          rayCaster.setFromCamera(this.pointer(e), ThreeView.get().wcCameras.camera.me);
          const intersection = new RayIntersection(rayCaster).getTargets(ThreeView.get().OctreeManager);
          if (intersection.length < 1) return;

          // 無限平面
          const plane = new THREE.Plane(intersection[0].face.normal);
          plane.translate(intersection[0].point);

          // 外壁のみ取得
          const outWall = (obj: THREE.Object3D) => obj.userData.sub_type && obj.userData.sub_type == 'OUT-WALL';
          const houseData = ThreeView.get().wcItemmgr.houseData.filter((data: THREE.Object3D) => {
            if (outWall(data)) return true;
          });
          const octreeManager = new OctreeManager(houseData);

          const t0 = performance.now();
          for (let i = 0; i < 10000; i++) {
            new PlaneHit(plane).getTagets(octreeManager);
          }
          const t1 = performance.now();

          console.log(`Call to doSomething took ${t1 - t0} milliseconds.`);
        });
      }
}

